<template>
  <section class="us-industry">
    <TitleHeader title="热门行业板块" />
    <div class="industry-scroll" v-loading="loading && !industries.length" element-loading-background="var(--theme-bg)">
      <table>
        <thead><tr><th>热门行业</th><th>最新价</th><th>领涨股</th><th>涨跌幅</th></tr></thead>
        <tbody>
          <tr v-for="item in sharedStockRows(industries, 'us', 'leader')" :key="item.bd_code" class="industry-row" tabindex="0" @click="selectedIndustry = item" @keydown.enter.self="selectedIndustry = item" @keydown.space.self.prevent="selectedIndustry = item">
            <td :title="item.bd_name"><button type="button" @click.stop="selectedIndustry = item">{{ item.bd_name }}</button></td>
            <td>{{ price(item.nzg_zxj) }}</td>
            <td :title="item.nzg_name">{{ item.nzg_name || '--' }}</td>
            <td :class="Number(item.nzg_zdf) < 0 ? 'fall' : Number(item.nzg_zdf) > 0 ? 'rise' : ''">{{ percent(item.nzg_zdf) }}</td>
          </tr>
          <tr v-if="error"><td colspan="4" role="alert">{{ error }} <button type="button" @click="load">重试</button></td></tr>
          <tr v-else-if="!loading && !industries.length"><td colspan="4">暂无行业数据</td></tr>
        </tbody>
      </table>
    </div>
    <USIndustryDialog :active="active" :industry="selectedIndustry" @close="selectedIndustry = null" @select-stock="selectStock" />
  </section>
</template>
<script>
import { quotePercent, quotePrice } from '@/utils/quoteDisplay'
import { sharedStockRows } from '@/utils/stockQuoteFeed'
import TitleHeader from '../../home/components/titleHeader.vue'
import USIndustryDialog from './USIndustryDialog.vue'
import { getUSIndustries } from '@/utils/usQuotes'
import { pollMarket } from '@/utils/marketRefresh'

export default {
  name: 'USIndustryPanel',
  components: { TitleHeader, USIndustryDialog },
  props: { active: { type: Boolean, default: true } },
  data: () => ({ industries: [], selectedIndustry: null, loading: false, error: '', requestId: 0 }),
  watch: { active(value) { if (value) this.activate(); else this.stopPolling() } },
  mounted() { if (this.active) this.activate() },
  beforeDestroy() { this.disposed = true; this.requestId++; this.stopPolling() },
  methods: {
    sharedStockRows,
    price: quotePrice,
    stopPolling() { if (this.stopRefresh) this.stopRefresh(); this.stopRefresh = null },
    async activate() {
      if (this.disposed || !this.active || this.stopRefresh) return
      try { await this.load(!this.industries.length) }
      finally {
        if (!this.disposed && this.active && !this.stopRefresh) this.stopRefresh = pollMarket(() => this.load(false), 'us')
      }
    },
    selectStock(item) { this.selectedIndustry = null; this.$emit('select-stock', item) },
    percent: quotePercent,
    async load(initial = true) {
      if (this.disposed || !this.active || this.loading) return
      initial = initial !== false
      const requestId = ++this.requestId
      this.loading = true; this.error = ''
      try {
        let industries = await getUSIndustries(initial)
        if (requestId !== this.requestId) return
        if (!initial) {
          const previous = new Map(this.industries.map(item => [item.bd_code, item]))
          industries = industries.map(item => ({ ...item, nzg_zxj: item.nzg_zxj == null ? (previous.get(item.bd_code) || {}).nzg_zxj : item.nzg_zxj }))
        }
        this.industries = industries
        // include_quote=1 already includes leader prices from the PC backend.
      } catch (_) {
        if (requestId === this.requestId) this.error = '行业行情加载失败，请重试。'
      } finally {
        if (requestId === this.requestId) this.loading = false
      }
    }
  }
}
</script>
<style scoped>
.us-industry { min-width: 0; min-height: 0; display: flex; flex-direction: column; background: var(--theme-bg); color: var(--theme-label); }
.industry-scroll { flex: 1; min-height: 0; overflow-y: auto; scrollbar-width: thin; scrollbar-color: #c1c1c1 #eee; }
table { width: 100%; table-layout: fixed; border-collapse: collapse; text-align: center; }
th, td { height: 31px; padding: 0 8px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-weight: normal; }
th { position: sticky; top: 0; z-index: 1; background: var(--theme-bg); }
button { padding: 0; border: 0; background: transparent; color: inherit; font: inherit; cursor: pointer; }
td:first-child button { width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.industry-row { cursor:pointer; }.industry-row:focus-visible { outline:2px solid var(--theme-accent); outline-offset:-2px; }
.rise { color: var(--quote-up); } .fall { color: var(--quote-down); }
</style>
